import { useState } from "react";

// Componentes
import { Modal, ModalBody, ModalHeader, Row, Col, Button } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import ButtonSpinner from "../../../../../components/Buttons/ButtonSpinner";

// Services
import { createEnabledEvent } from "../../../../../utils/services/portalBoticario";

export const ModalNewEnabledEvent = ({ isOpen, toggle, jwt, refetch }) => {
  // state do formulário
  const [eventId, setEventId] = useState("");

  // state de controle
  const [error, setError] = useState("");
  const [apiError, setApiError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isShowSuccess, setIsShowSuccess] = useState(false);

  // traduz mensagem de erro da API para texto amigável
  const getApiErrorMessage = (message) => {
    const map = {
      EVENT_ALREADY_ENABLED: "Este evento já está habilitado.",
      EVENT_NOT_FOUND: "Evento não encontrado.",
    };
    return (
      map[message] ||
      message ||
      "Erro ao conectar com o servidor. Verifique sua conexão."
    );
  };

  const UUID_REGEX =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!eventId.trim()) {
      setError("Campo obrigatório");
      return;
    }

    if (!UUID_REGEX.test(eventId.trim())) {
      setError("Informe um UUID válido (ex: 550e8400-e29b-41d4-a716-446655440000)");
      return;
    }

    setError("");
    setApiError("");
    setIsLoading(true);

    try {
      await createEnabledEvent({ eventId: eventId.trim() }, jwt);
      refetch();
      setIsShowSuccess(true);
    } catch (err) {
      const message = err.response?.data?.message;
      setApiError(getApiErrorMessage(message));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} centered autoFocus>
      <ModalHeader toggle={toggle}>Habilitar Evento</ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <Row>
            <Col lg={12} style={{ marginBottom: 10 }}>
              <label className="form-label">ID do Evento *</label>
              <input
                className="form-control"
                type="text"
                value={eventId}
                onChange={(e) => {
                  setEventId(e.target.value);
                  if (error) setError("");
                }}
                placeholder="UUID do evento"
              />
              {error && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {error}
                </span>
              )}
            </Col>
          </Row>

          {apiError && (
            <Row>
              <Col lg={12} style={{ marginBottom: 10 }}>
                <span className="text-danger" style={{ fontSize: 13 }}>
                  {apiError}
                </span>
              </Col>
            </Row>
          )}

          <Row>
            <Col
              md={12}
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 10,
              }}
            >
              <Button
                color="danger"
                style={{ width: 80, marginRight: 10 }}
                onClick={toggle}
                disabled={isLoading}
              >
                Fechar
              </Button>
              <ButtonSpinner
                title="Salvar"
                type="submit"
                isLoading={isLoading}
              />
            </Col>
          </Row>
        </form>
      </ModalBody>

      {isShowSuccess && (
        <SweetAlert
          title="Habilitado!"
          success
          onConfirm={() => {
            setIsShowSuccess(false);
            toggle();
          }}
        >
          Evento habilitado com sucesso!
        </SweetAlert>
      )}
    </Modal>
  );
};
